import { portalApiClient, withAuthHeaders } from '@/utilities/api'

export const getClientUser = ({
  clientId,
  authUserIdOverride,
}: {
  clientId: string
  authUserIdOverride?: string | number | null
}) => {
  return portalApiClient.profile_v2_clients_users_me_get(
    withAuthHeaders({
      queries: { partner_id: clientId },
      headers:
        authUserIdOverride == null ? {} : { 'x-auth-user-id-override': String(authUserIdOverride) },
    }),
  )
}

const userRepository = {
  getClientUser,
}

export default userRepository
